export const HOVER_UNSUPPORTED_QUERY = '(hover: none)';
